import { header } from './header.i18n';

export const en = {
  header,
};
